import React from 'react';

export default function NuroaLogo() {
  return (
    <svg
      className="NuroaLogo"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="300"
      height="169"
      viewBox="0 0 300 169"
    >
      <defs>
        <linearGradient
          id="prefix__b"
          x1="62.959%"
          x2="64.569%"
          y1="49.751%"
          y2="106.279%"
        >
          <stop offset="0%" stopColor="#1F67AC" />
          <stop offset="100%" stopColor="#244D87" />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1="49.985%"
          x2="32.281%"
          y1="46.848%"
          y2="100.58%"
        >
          <stop offset="0%" stopColor="#528AB3" />
          <stop offset="100%" stopColor="#1F67AC" />
        </linearGradient>
        <linearGradient
          id="prefix__h"
          x1="56.521%"
          x2="32.291%"
          y1="36.245%"
          y2="87.359%"
        >
          <stop offset="0%" stopColor="#528AB3" />
          <stop offset="100%" stopColor="#1F67AC" />
        </linearGradient>
        <linearGradient
          id="prefix__k"
          x1="60.138%"
          x2="27.381%"
          y1="26.876%"
          y2="76.286%"
        >
          <stop offset="0%" stopColor="#528AB3" />
          <stop offset="100%" stopColor="#1F67AC" />
        </linearGradient>
        <path
          id="prefix__a"
          d="M8.12 5.011C3.423 8.95 1.174 14.79 1.51 20.688c.247 4.258 1.847 8.547 4.855 12.158l.175.208c4.12 4.83 9.915 7.354 15.637 7.365h.035c4.262 0 8.482-1.394 11.941-4.269.066-.055.133-.11.198-.166l.012-.006-.012.067 8.126-6.948 11.368-9.712s1.148-1.149 3.137-2.719a33.858 33.858 0 00-3.4-7.88 38.895 38.895 0 00-5.349 2.885s-4.95 3.612-9.299-1.436v.018a32.521 32.521 0 00-8.715-6.847 19.797 19.797 0 00-2.623-1.265l-.15-.078-.006.018A20.18 20.18 0 0020.129.69c-4.295 0-8.545 1.415-12.009 4.32M1.27 23.256L.53 52.474a18.58 18.58 0 00.71 5.615c5.855 3.765 12.536 5.647 20.047 5.647 9.37 0 17.472-2.957 24.293-8.87.357-1.597.608-3.335.74-5.222.71-10.148-2.214-15.373-3.843-20.547l-8.126 6.948.012-.067-.012.006c-.065.056-.132.111-.198.166-3.459 2.875-7.679 4.269-11.941 4.269h-.035c-5.724-.01-11.517-2.533-15.637-7.365l-.175-.208c-3.008-3.611-4.608-7.9-4.855-12.158a19.012 19.012 0 00-.24 2.568"
        />
        <path
          id="prefix__d"
          d="M3.059 14.874C.164 22.967.07 30.281 2.845 31.197c2.779.908 7.377-4.93 10.263-13.029C15.988 10.084 11.827 1.707 9.058.8a1.536 1.536 0 00-.47-.08c-2.354.001-2.815 6.56-5.53 14.155"
        />
        <path
          id="prefix__g"
          d="M6.241 13.951C1.327 22.728-.6 30.945 1.954 32.293c2.558 1.35 8.624-4.692 13.54-13.476 4.9-8.77 6.8-16.946 4.247-18.285a1.707 1.707 0 00-.806-.187c-2.868.001-8.241 5.673-12.694 13.606"
        />
        <path
          id="prefix__j"
          d="M8.772 13.604C2.182 22.84-1.388 31.556.808 33.042c2.202 1.485 9.337-4.829 15.925-14.076C23.314 9.732 30.615 3.238 28.921 1.204 28.24.387 27.298.014 26.177.014c-4.566 0-12.118 6.181-17.405 13.59"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M201.764 58.71c10.272 0 19.018 3.579 26.252 10.726 7.236 7.148 10.858 15.795 10.858 25.942 0 10.181-3.615 18.836-10.833 25.967-7.218 7.14-15.98 10.71-26.277 10.71-10.331 0-19.093-3.561-26.294-10.684-7.21-7.124-10.806-15.778-10.806-25.993 0-10.171 3.606-18.826 10.822-25.966 7.228-7.131 15.98-10.702 26.278-10.702"
        />
        <path
          fill="#2068AC"
          d="M14.906 83.733l-.101.543v39.398a35.03 35.03 0 01-3.004.349c-1.469.11-2.787.16-3.913.16-1.2 0-2.553-.05-4.023-.16a34.22 34.22 0 01-3.002-.35v-50.63c2.163-.677 4.694-1.35 7.55-2.012 3.493-.805 7.958-1.213 13.26-1.213 3.083 0 6.215.27 9.31.796 2.89.497 5.53 1.54 7.848 3.116 2.26 1.533 4.144 3.798 5.61 6.733 1.483 2.972 2.234 7.048 2.234 12.115v31.097a35.08 35.08 0 01-3.002.349c-1.47.11-2.788.16-3.914.16-1.2 0-2.553-.05-4.022-.16-.92-.062-1.925-.18-3.003-.35V94.57c0-4.54-.912-7.796-2.78-9.956-1.936-2.227-4.795-3.355-8.503-3.355-.919 0-1.918.083-2.957.248-1.355.219-2.094.446-2.636.805l-.439.44m62.253 41.49c-3.594 0-7.096-.29-10.409-.854-3.103-.527-5.846-1.61-8.16-3.21-2.242-1.554-4.068-3.869-5.425-6.889-1.398-3.103-2.107-7.41-2.107-12.804V70.11a32.482 32.482 0 012.667-.357 45.89 45.89 0 014.359-.216c1.313 0 2.762.072 4.307.216.877.08 1.751.193 2.608.345v28.84c0 5.083.92 8.57 2.817 10.657 1.923 2.123 4.77 3.2 8.461 3.2 1.36 0 2.385-.037 3.128-.12.777-.086 1.336-.173 1.747-.279l.647-.291.555-.556.395-.71.18-.73V70.111a32.344 32.344 0 012.666-.357 45.975 45.975 0 014.36-.216c1.313 0 2.762.072 4.307.216.877.08 1.75.193 2.608.345v50.918c-.824.249-1.726.501-2.7.752a125.69 125.69 0 01-5.409 1.248c-1.886.392-3.83.696-5.786.905-1.97.21-3.923.32-5.816.32m32.513-.059c-1.2 0-2.51-.05-3.904-.156-.87-.067-1.84-.184-2.902-.348V70.874c2.785-.329 5.664-.61 8.59-.843 3.65-.29 7.13-.434 10.348-.434 8.33 0 14.586 1.533 18.601 4.56 3.86 2.915 5.736 6.91 5.736 12.222 0 2.04-.226 3.818-.672 5.291-.453 1.496-1.003 2.784-1.637 3.837-.618 1.015-1.252 1.828-1.885 2.404-.79.72-1.432 1.294-1.936 1.726l-1.478 1.175.928 1.707 11.047 21.197c-.483.055-.982.1-1.494.142a61.292 61.292 0 01-5.048.215c-1.982 0-3.925-.07-5.773-.215a36.163 36.163 0 01-3.3-.387l-10.813-23.075c2.78-1.643 4.686-3.403 5.82-5.368a12.955 12.955 0 001.75-6.545c0-2.526-.789-4.653-2.347-6.316-1.6-1.706-4.01-2.569-7.172-2.569-1.567 0-2.763.089-3.657.27l-.8.247-.683.513-.317.708-.09.84v41.498a35.023 35.023 0 01-3.002.349c-1.467.11-2.784.16-3.91.16m169.113-.14c-3.632 0-7.004-.337-10.032-.999-2.884-.634-5.374-1.65-7.399-3.021-1.96-1.337-3.455-3.053-4.567-5.256-1.114-2.202-1.68-4.99-1.68-8.282 0-3.131.65-5.712 1.936-7.674a15.244 15.244 0 015.16-4.894c2.187-1.262 4.65-2.156 7.311-2.656 2.787-.522 5.534-.787 8.167-.787h6.732l.841-.314.682-.707.562-.735.257-.732c-.1-1.8-.63-3.344-1.57-4.603a8.934 8.934 0 00-3.422-2.771c-1.235-.573-2.6-.972-4.07-1.188a28.835 28.835 0 00-4.199-.303c-1.881 0-4.093.215-6.576.645-1.855.32-3.77.787-5.71 1.389a72.546 72.546 0 01-.748-1.553c-.41-.885-.73-1.8-.947-2.716-.231-.948-.4-1.95-.501-2.99a33.47 33.47 0 01-.126-1.992 67.054 67.054 0 018.545-2.043c3.348-.564 6.387-.85 9.04-.85 3.574 0 6.836.43 9.696 1.284 2.743.817 5.098 2.089 7.004 3.77 1.874 1.658 3.351 3.831 4.383 6.454 1.064 2.699 1.602 6 1.602 9.811v30.626c-2.386.636-5.157 1.28-8.265 1.916-3.805.775-7.877 1.17-12.106 1.17zm-.66-26.554c-3.009 0-5.617.677-7.75 2.016-2.458 1.54-3.754 3.837-3.754 6.645 0 2.004.504 3.67 1.49 4.935a8.766 8.766 0 003.38 2.641c1.196.531 2.49.893 3.851 1.07 1.218.155 2.376.235 3.443.235.777 0 1.806-.075 3.145-.235 1.39-.165 2.36-.32 3.054-.498l.709-.474.432-.548.373-.565.194-.33.068-.369V99.843l-.189-.809-.489-.684-.754-.61-.915-.25h-6.287z"
        />
        <path
          fill="#AAE7F8"
          d="M185.511 146.463s16.35 1.444 16.35 21.61c0-20.439 16.36-21.61 16.36-21.61l-1.018-.032h17.99c6.342 0 9.876-2.716 10.215-6.112l8.063-81.343c.027-.266.042-.532.042-.797l14.505-.15a3.757 3.757 0 003.536-2.623 3.814 3.814 0 00-1.35-4.21C246.164 33.365 209.81 6.191 205.59 2.471a3.804 3.804 0 00-3.039-1.543c-1.2 0-2.31.58-3.014 1.511-4.305 3.735-42.246 31.73-67.357 50.119-1.672 1.228-2.045 3.595-.828 5.289a3.732 3.732 0 003.635 1.51c.215.034.422.059.645.05l14.662-.158 8.032 81.07c.33 3.396 3.865 6.112 5.587 6.112h22.643l-1.044.032z"
        />
        <path
          fill="#FFF"
          d="M201.765 58.71c10.271 0 19.017 3.58 26.251 10.726 7.236 7.149 10.859 15.796 10.859 25.942 0 10.18-3.615 18.836-10.833 25.968-7.218 7.14-15.98 10.709-26.277 10.709-10.331 0-19.093-3.561-26.294-10.684-7.211-7.125-10.807-15.779-10.807-25.993 0-10.17 3.606-18.827 10.822-25.967 7.228-7.132 15.98-10.7 26.278-10.7"
        />
        <path
          stroke="#8ABDDD"
          strokeWidth="1.195"
          d="M201.765 58.71c10.271 0 19.017 3.58 26.251 10.726 7.236 7.149 10.859 15.796 10.859 25.942 0 10.18-3.615 18.836-10.833 25.968-7.218 7.14-15.98 10.709-26.277 10.709-10.331 0-19.093-3.561-26.294-10.684-7.211-7.125-10.807-15.779-10.807-25.993 0-10.17 3.606-18.827 10.822-25.967 7.228-7.132 15.98-10.7 26.278-10.7z"
        />
        <g transform="translate(180.478 68.32)">
          <mask id="prefix__c" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            fill="url(#prefix__b)"
            d="M8.12 5.011C3.423 8.95 1.174 14.79 1.51 20.688c.247 4.258 1.847 8.547 4.855 12.158l.175.208c4.12 4.83 9.915 7.354 15.637 7.365h.035c4.262 0 8.482-1.394 11.941-4.269.066-.055.133-.11.198-.166l.012-.006-.012.067 8.126-6.948 11.368-9.712s1.148-1.149 3.137-2.719a33.858 33.858 0 00-3.4-7.88 38.895 38.895 0 00-5.349 2.885s-4.95 3.612-9.299-1.436v.018a32.521 32.521 0 00-8.715-6.847 19.797 19.797 0 00-2.623-1.265l-.15-.078-.006.018A20.18 20.18 0 0020.129.69c-4.295 0-8.545 1.415-12.009 4.32M1.27 23.256L.53 52.474a18.58 18.58 0 00.71 5.615c5.855 3.765 12.536 5.647 20.047 5.647 9.37 0 17.472-2.957 24.293-8.87.357-1.597.608-3.335.74-5.222.71-10.148-2.214-15.373-3.843-20.547l-8.126 6.948.012-.067-.012.006c-.065.056-.132.111-.198.166-3.459 2.875-7.679 4.269-11.941 4.269h-.035c-5.724-.01-11.517-2.533-15.637-7.365l-.175-.208c-3.008-3.611-4.608-7.9-4.855-12.158a19.012 19.012 0 00-.24 2.568"
            mask="url(#prefix__c)"
          />
        </g>
        <path
          fill="#2068AC"
          d="M199.256 85.913c7.23 8.692-2.518 2.291 5.655-4.694l23.597 3.28 2.925 1.61-8.478 11.307 11.368-9.713s9.586-9.582 21.297-11.217c0 0-11.536-6.351-26.909 3.505 0 0-4.95 3.61-9.299-1.438v.018a32.533 32.533 0 00-8.715-6.845 19.87 19.87 0 00-2.623-1.267l-.15-.077-.006.018c-6.453-2.521-13.864-1.647-19.32 2.93-4.697 3.94-6.946 9.778-6.61 15.676.248 4.26 14.26-6.706 17.268-3.093m23.699 11.503l-8.126 6.949.012-.068-.012.007m-32.84-15.298c-.139.84-.217 1.695-.24 2.57l-.742 29.218"
        />
        <g transform="translate(187.65 107.872)">
          <mask id="prefix__f" fill="#fff">
            <use xlinkHref="#prefix__d" />
          </mask>
          <path
            fill="url(#prefix__e)"
            d="M3.059 14.874C.164 22.967.07 30.281 2.845 31.197c2.779.908 7.377-4.93 10.263-13.029C15.988 10.084 11.827 1.707 9.058.8a1.536 1.536 0 00-.47-.08c-2.354.001-2.815 6.56-5.53 14.155"
            mask="url(#prefix__f)"
          />
        </g>
        <g transform="translate(176.892 107.872)">
          <mask id="prefix__i" fill="#fff">
            <use xlinkHref="#prefix__g" />
          </mask>
          <path
            fill="url(#prefix__h)"
            d="M6.241 13.951C1.327 22.728-.6 30.945 1.954 32.293c2.558 1.35 8.624-4.692 13.54-13.476 4.9-8.77 6.8-16.946 4.247-18.285a1.707 1.707 0 00-.806-.187c-2.868.001-8.241 5.673-12.694 13.606"
            mask="url(#prefix__i)"
          />
        </g>
        <g transform="translate(168.33 107.674)">
          <mask id="prefix__l" fill="#fff">
            <use xlinkHref="#prefix__j" />
          </mask>
          <path
            fill="url(#prefix__k)"
            d="M8.772 13.604C2.182 22.84-1.388 31.556.808 33.042c2.202 1.485 9.337-4.829 15.925-14.076C23.314 9.732 30.615 3.238 28.921 1.204 28.24.387 27.298.014 26.177.014c-4.566 0-12.118 6.181-17.405 13.59"
            mask="url(#prefix__l)"
          />
        </g>
      </g>
    </svg>
  );
}
